import React, { useState, useRef, useEffect } from 'react';
import { AlertTriangle, Lock, X } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from './utils';

const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, itemDescription }) => {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const inputRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      setPassword('');
      setError('');
      setTimeout(() => inputRef.current?.focus(), 100);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password.trim()) {
      setError('Mot de passe requis');
      return;
    }
    setLoading(true);
    setError('');
    try {
      await axios.post(`${API}/admin/verify-delete-password`, { password }, { withCredentials: true });
      onConfirm();
      onClose();
    } catch (err) {
      setError(err.response?.data?.detail || 'Mot de passe incorrect');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-[100]" onClick={onClose}>
      <div className="bg-slate-900 rounded-xl border border-red-500/30 p-6 w-full max-w-md" onClick={e => e.stopPropagation()}>
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-full bg-red-500/20 flex items-center justify-center">
            <AlertTriangle className="w-5 h-5 text-red-400" />
          </div>
          <div>
            <h3 className="text-lg font-bold text-white">Confirmation de suppression</h3>
            <p className="text-sm text-slate-400">Cette action est irréversible</p>
          </div>
          <button onClick={onClose} className="ml-auto text-slate-400 hover:text-white">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="bg-red-500/10 border border-red-500/20 rounded-lg p-3 mb-4">
          <p className="text-sm text-red-300">{itemDescription}</p>
        </div>

        <form onSubmit={handleSubmit}>
          <label className="text-sm text-slate-400 mb-1 block">
            <Lock className="w-3 h-3 inline mr-1" />
            Mot de passe logistique
          </label>
          <Input
            ref={inputRef}
            type="password"
            placeholder="Mot de passe de suppression..."
            className="bg-slate-800 border-slate-700 text-white mb-2"
            value={password}
            onChange={(e) => { setPassword(e.target.value); setError(''); }}
            data-testid="delete-confirm-password"
          />
          {error && <p className="text-red-400 text-xs mb-2">{error}</p>}

          <div className="flex gap-3 mt-4">
            <Button
              type="button"
              variant="ghost"
              className="flex-1 text-slate-400 hover:text-white"
              onClick={onClose}
            >
              Annuler
            </Button>
            <Button
              type="submit"
              className="flex-1 bg-red-600 hover:bg-red-700 text-white"
              disabled={loading}
              data-testid="delete-confirm-submit"
            >
              {loading ? 'Vérification...' : 'Supprimer'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
